export default __webpack_public_path__ + "static/media/it_2.2ea41881.mp3";